var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fast-fade","mode":"out-in"}},[(_vm.loading)?_c('div',{staticClass:"overlay-loading print-d-none",class:{ 'overlay-dark': _vm.theme == 'dark' }},[_c('div',{staticClass:"overlay-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"spinner-border text-theme",attrs:{"role":"status"}})])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }